import { useNavigate } from 'react-router-dom';
import { BackButton } from '@/components/common/BackButton';
import { useCurrentUser } from '@/context/AuthContext';
import { getDisplayName, getEmailOrHandle, getSpreadsRemaining } from '@/api/selectors';
import { t } from '@/i18n';
import styles from './ProfileHeader.module.css';

const DEFAULT_AVATAR = String.fromCodePoint(0x1f464);

export function ProfileHeader() {
  const navigate = useNavigate();
  const user = useCurrentUser();
  const spreads = getSpreadsRemaining(user);
  const displayName = getDisplayName(user).replace(/\.$/, '');
  const contact = getEmailOrHandle(user);

  return (
    <section className={styles.root}>
      <div className={styles.hero}>
        <BackButton className={styles.back} onClick={() => navigate(-1)} />
        <div className={styles.profileRow}>
          <div className={styles.ava} aria-hidden>
            {DEFAULT_AVATAR}
          </div>
          <div className={styles.meta}>
            <div className={styles.nm}>{displayName}</div>
            <div className={styles.eml}>{contact}</div>
          </div>
        </div>
      </div>
      <div className={styles.balanceCard}>
        <div className={styles.balTitle}>{t.profile.balanceTitle}</div>
        <div className={styles.balNum}>{spreads}</div>
        <div className={styles.balSub}>{t.profile.balanceSub}</div>
      </div>
    </section>
  );
}
